<template>

  <div class="pageIntro">
    <h2>Lets talk about it</h2>
  </div>

  <div class="contact">
    <div class="left">
      <router-link v-for="pic in pics" :key="pic.link" v-bind:to="`/${pic.link}`" @click="updateTitle(pic.link)"
        class="photoBox">
        <polaroid-pic :imgFile="pic.imgFile"></polaroid-pic>
      </router-link>
    </div>
    <div class="right">
      <div class="leadRow">
        <p class="emph">Jennifer Baldwin</p>
        <div class="pageIntro">
          <h3>Full-time employment & project-based work</h3>
          <!-- <h3>Full-time employment &</h3> -->
          <!-- <h3>project-based work</h3> -->
        </div>
      </div>
      <!-- <div class="row">
        <div class="pageIntro">
          <h3>Full-time employment &</h3>
          <h3>project-based work</h3>
        </div>
      </div> -->
      <div class="middle">
        <div class="row">
          <span>email:</span>
          <p class="email">JBldwn@iu.edu</p>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <span></span>
          <p class="email">Jenli.Bldwn@gmail.com</p>
        </div>
        <div class="row">
          <span>graduated:</span>
          <p>May 2025</p>
        </div>

      </div>
      <div class="last">
        <div class="smLinks">
          <a href="https://github.com/jbldwn/" target="_blank" class="eLink">
            <font-awesome-icon class="smlogo first" icon="fa-brands fa-github" />
          </a>
          <a href="https://www.linkedin.com/in/jenbldwn/" target="_blank" class="eLink">
            <font-awesome-icon class="smlogo" icon="fa-brands fa-linkedin" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pics: [
        {
          imgFile: "graduate.jpg",
          link: "portfolio",
          alt: "A waist- up photo of a woman in a cap and gown, smiling while holding the tassel of her graduation cap.She has long brown hair and is wearing a white lace dress with a red stole and a strand of pearls.The photo is taken from a low angle, with a large, modern building in the background.",
        },
      ],
    };
  },
  emits: ["updateTitle"],
  props: {
    pTitle: String,
  },
  methods: {
    updateTitle(newTitle) {
      this.$emit("updateTitle", newTitle);
    },
  },
};
</script>
<style scoped>
/* Contact Styles */
.contact {
  /* alignment */
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: auto 0;
  margin-top: 20px;
}

.contact .left {
  width: 40%;
  margin: 0;
}

.contact .right {
  height: 350px;
  /* Style */
  background-color: rgba(240, 255, 255, 0.3);
  border-radius: 30px;
  padding: 25px;
  width: 50%;
  /* Layout */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Text */
  font-size: 20px;
  font-family: sans-serif;
  /* display: flex;
  align-items: stretch;
  justify-content: space-evenly;
  flex-direction: column;
  border: solid red 1px;
  height: 100%; */

}

.contact .right .leadRow {
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
  /* text-wrap: nowrap; */

}

* {
  /* border: solid red 1px; */
}

.contact .right .leadRow .emph {
  font-size: 2.2vw;
  margin-bottom: 0;
}

.contact .right .leadRow .pageIntro {
  /* margin-left: 10px; */
  padding-left: 2em;
  /* Creates space for the indentation */
  text-indent: -2em;
  /* Pulls the first line back into the padding */
}

.contact .right .leadRow .pageIntro h3 {
  flex-wrap: wrap;
  font-size: 1.5vw;
  font-size: 18px;
}

.contact .right .row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}



.contact .right .last .smLinks {
  display: flex;
}

.contact .right .last .smLinks .smlogo {
  font-size: 35px;
  color: rgba(0, 0, 0, 0.7);
}

.contact .right .last .smLinks .smlogo:last-child {
  margin-left: 15px;
}

.contact .right .last .smLinks .eLink:hover .smlogo,
{
color: rgb(240, 240, 255);
filter: drop-shadow(1px 2px 4px rgb(51, 51, 51));
}

.contact .right .last:last-child {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: end;
}

.contact .right .row span {
  align-self: flex-start;
  font-weight: 800;
  font-family: "typeBld";
  font-size: 18px;
  color: rgba(0, 0, 0, 0.7);
}

.contact .right .row p {
  font-size: 16px;
  align-self: center;
  margin-bottom: 0px;
}

.contact .right .row h3 {
  font-size: 18px;
  line-height: 18px;
  margin-bottom: 0px;
}

.contact .right .middle {
  height: 40%;
  padding-left: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.contact .right:hover {
  background: linear-gradient(320deg, rgba(240, 255, 255, 0.45), rgba(240, 255, 255, 0.25), rgba(240, 255, 255, 0.1) 70.71%);
}

.contact .right:hover .smlogo {
  filter: drop-shadow(0 0 10px rgb(240, 240, 255));
  color: rgba(240, 240, 255, 0.8);
}

.contact .right:hover .tag {
  filter: drop-shadow(0 0 10px rgba(240, 240, 255, 0.5));
}

.contact .right :hover .tag:hover {
  filter: drop-shadow(1px 2px 4px rgb(51, 51, 51));
}

/* Small Desktop */
@media only screen and (max-width: 1350px) {
  .contact .right .myInfo .leadRow .smLinks .smlogo {
    font-size: 25px;
  }

  .contact .right .myInfo .row h3 {
    font-size: 16px;
  }

  .contact .right .myInfo .leadRow .emph {
    font-size: 20px;
  }
}

/* Tablet */
@media only screen and (max-width: 915px) {
  .contact {
    flex-direction: column;
    /* justify-content: space-between; */
  }

  .contact .left {
    width: 60%;
    margin-left: 15px;
  }

  .contact .right {
    width: 100%;
    margin-left: 30px;
    height: 275px;
    margin-top: 20px;
  }

  .contact .right .leadRow .emph {
    font-size: 20px;
  }

  .contact .right .leadRow .pageIntro {
    margin-left: 10px;
  }

  .contact .right .row h3 {
    font-size: 16px;
  }



  .contact .right .row .pageIntro h3 {
    font-size: 16px;
  }
}

/* Mobile */
@media only screen and (max-width: 560px) {
  .contact {
    flex-direction: column-reverse;
  }

  .contact .left {
    width: 60%;
    margin-bottom: 15px;
  }

  .contact .right {
    width: 100%;
    margin: 15px 0px;
  }

  .contact .right .myInfo {
    margin: 15px 0 15px;
    width: 100%;
  }

  .contact .right .myInfo .leadRow .smLinks .smlogo {
    font-size: 25px;
  }

  .contact .right .myInfo .row h3 {
    font-size: 16px;
  }

  .contact .right .myInfo .leadRow .emph {
    font-size: 20px;
  }
}

/* END Contact Styles */
</style>
